import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import TableColumn from '../TableColumn';
import { useDispatch } from 'react-redux';
import { saveIsThreeDaysSearch, setIsNewSearch } from '@shared/redux/actions';
import { grayCell, cellDay, cellMonths } from '../cellStyles';

const OneWayWs = ({
  setDate,
  cheapestFlightPrice,
  setDateFormat,
  isInUSD,
  currentSearch,
}) => {
  const dispatch = useDispatch();

  // Estado para forzar el re-render
  const [version, setVersion] = useState(0);
  const [prevResultsJson, setPrevResultsJson] = useState(
    JSON.stringify(window.vthws?.results)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const currentJson = JSON.stringify(window.vthws?.results);
      if (currentJson !== prevResultsJson && version > -1) {
        setPrevResultsJson(currentJson);
        setVersion(v => v + 1); // Fuerza el re-render
      }
    }, 1000); // Cada 1 segundo

    return () => clearInterval(interval);
  }, [prevResultsJson]);

  const handleNewSearch = selectedCell => {
    if (window.vthws && !window.vthws?.searching) {
      window.vthws.searchObject.arrayLegs[0].FlightDate = selectedCell?.data[0]?.horaSalida.split(
        'T'
      )[0];
      window.vthws?.searchInit(window.vthws?.searchObject);
      dispatch(
        setIsNewSearch({
          isNewSearch: true,
          searchType: currentSearch?.search_type,
        })
      );
      dispatch(
        saveIsThreeDaysSearch({
          oneWay: true,
          roundTrip: false,
          new_go_date: setDateFormat(
            selectedCell?.data[0]?.horaSalida.split('T')[0]
          ),
        })
      );
    }
  };

  const mapMatrixGo = () => {
    const tab = [];
    const minLength = /*screenSizeWidth < 600 ? numCell :*/ 0;
    const maxLength =
      /*screenSizeWidth < 600
        ? 3 + minLength
        :*/ window.vthws
        ?.results?.length || 0;

    for (let index = minLength; index < maxLength; index++) {
      const goIndex = /*screenSizeWidth < 600 ? index - 1 :*/ index;
      const arrayFlights = window.vthws?.results[goIndex];
      const firstCell = arrayFlights;
      const cell = window.vthws?.results[+goIndex];

      const dateSet = setDate(new Date(firstCell?.data?.[0]?.horaSalida + ''));

      tab.push(
        <Grid
          item
          key={`date_go_${+goIndex}`}
          sx={{
            minWidth: {
              xs: `${100 / 3}%`,
              sm: `${100 / 7}%`,
            },
          }}
        >
          <Grid item>
            <Typography
              component="span"
              sx={{
                ...grayCell,
                ...cellDay,
              }}
            >
              {dateSet?.day}
              <Typography
                sx={{
                  ...grayCell,
                  ...cellMonths,
                }}
              >
                {dateSet?.months}
              </Typography>
            </Typography>
          </Grid>

          <TableColumn
            key={`go_${+goIndex}`}
            goIndex={goIndex}
            cell={cell}
            cheapestFlightPrice={cheapestFlightPrice}
            handleNewSearch={handleNewSearch}
            isInUSD={isInUSD}
          />
        </Grid>
      );
    }

    return tab;
  };

  // Esta llamada se re-ejecuta cuando cambia `version`
  return mapMatrixGo();
};

export default OneWayWs;
